import { IsOnlineNow } from 'utils'
import { FlexDiv } from 'components/generic/HomePageComponents'
import LastSeen from './LastSeen'
import { OnlineNowDot } from './Styled'

const OnlineStatus = ({ lastOnline, listingPath }) => {
  const displayAsOnline = IsOnlineNow(lastOnline, listingPath)

  return (
    <FlexDiv
      display='inline'
      mt={{ _: '.5rem', tablet: '0' }}
      ml={{ _: '0', tablet: '.5rem' }}
      mb='.5rem'
    >
      {displayAsOnline && <OnlineNowDot />}
      <>{lastOnline && <LastSeen lastOnline={lastOnline} listingPath={listingPath} />}</>
    </FlexDiv>
  )
}

export default OnlineStatus
